export const E100_PORTAL_SUBSCRIPTION_LINK = 'https://clients.e100.eu/clients/documents';